import { faSpinner, faWarning } from "@fortawesome/pro-regular-svg-icons";
import { m } from "motion/react";

import { DATASET_JOB_TIMEOUT } from "src/datasets/utils";
import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { DatasetJob } from "src/jobs/types";

const tooltipContent = {
  pending: {
    title: "Dataset Processing...",
    body: "This dataset is being processed. This might take a few minutes.",
  },
  failed: {
    title: "Dataset Processing Failed",
  },
} as const;

export const DatasetStatusPill = ({
  status,
  errorMsg,
}: {
  status: DatasetJob["status"];
  errorMsg?: string;
}) => {
  const isFailed = status === "FAILED";
  return (
    <m.div
      animate={{
        opacity: 1,
        transition: {
          type: "tween",
          ease: "easeOut",
          delay: 0.15,
        },
      }}
      initial={{ opacity: 0 }}
      transition={{ type: "tween", ease: "easeOut" }}
      layout
    >
      <Tooltip
        placement="top"
        {...(isFailed
          ? { ...tooltipContent.failed, body: errorMsg ?? DATASET_JOB_TIMEOUT }
          : tooltipContent.pending)}
      >
        <div>
          <Pill variant={isFailed ? "red" : "yellow"}>
            <Pill.Icon
              icon={isFailed ? faWarning : faSpinner}
              spin={!isFailed}
            />
            <Pill.Text>{isFailed ? "Failed" : "Processing"}</Pill.Text>
          </Pill>
        </div>
      </Tooltip>
    </m.div>
  );
};
